<template>
	<v-layout 
		row wrap
		align-center
		class="form-step-one"
		:class="[ isQinti ? 'back-qinti' : isLucky ? 'backL' : 'primary']"
	>
		<v-flex xs12 primary class="form-step-one-container-title">
			<v-layout wrap>
				<v-btn
					v-if="showForm && !isForm"
					class="form-btn-close"
					depressed
					flat
					icon
					@click="$emit('close-form')"
				>
					<v-icon color="white">close</v-icon>
				</v-btn>
				<v-flex xs12>
					<img
						src="/static/images-new/logos/logo-banner.svg"
						alt="logo casamarket"
						height="64"
						v-if="isQinti"
					/>
					<img
						src="/static/images-new/logos/logo-banner-lucky.png"
						alt="logo casamarket"
						height="64"
						v-if="isLucky"
					/>
					<img
						src="/static/images-new/logos/logo-casamarket-white-mini.svg"
						alt="logo casamarket"
						height="64"
						v-else
					/>
				</v-flex>
				<v-flex xs12>
					<h2 class="white--text w-black form-step-one-title">
						¡TU NEGOCIO FUE REGISTRADO CON ÉXITO!
					</h2>
				</v-flex>
				<v-flex xs12>
					<p class="white--text w-semibold form-step-one-description">
						En unos minutos te enviaremos tus accesos por whatsapp
					</p>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 class="form-step-one-container-buttons">
			<p v-if="url.length">Mira tu catálogo <br/>
				desde: <a :href="url" class="link-here" target="_blank">AQUÍ</a>
			</p>
			<p>Gestiona tu tienda desde:</p>
			<v-layout justify-center>
				<v-flex xs4>
					<a class="link-here link-admin" target="_blank" href="https://admin.casamarket.la">
						<img src="/static/images-new/sections/computer.svg" class="mr-2">
						<span>Web</span>
					</a>
				</v-flex>
				<v-flex xs4>
					<a class="link-here link-admin" target="_blank" href="https://play.google.com/store/apps/details?id=com.quipu.makipos.bodega">
						<img src="/static/images-new/sections/smartphone.svg" alt="" class="mr-2">
						<span>App</span>
					</a>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	export default {
		name: 'form-step-one',
		computed: {
			isQinti,
			isLucky,
		},
		props: {
			showForm: {
				default: false,
				type: Boolean,
			},
			url: String,
		},
	};
</script>

<style lang="scss" scoped>
	.form-step-one {
		color: color(newwarning);
		height: 91%;
		font-size: 22px;
		left: 17px;
		padding: 70px 0 0 0;
		position: absolute;
		top: 19px;
		width: 91%;

		&-title {
			font-size: 25px;
			letter-spacing: normal;
			line-height: normal;
			margin: 28px auto 41px;
			max-width: 210px;

			span {
				font-size: size(big39);
			}
		}

		&-btn {
			border-radius: 5px;
			color: color(white);
			font-size: size(medium18);
			font-weight: weight(black);
			height: 64px;
			width: 205px;
		}

		&-container {
			bottom: 255px;
			position: relative;
			z-index: 1;
		}

		&-description {
			font-size: size(large);
		}

		&-container-title {
			position: relative;

			&::before {
				background-color: color(primary);
				bottom: -11px;
				content: '';
				height: 12px;
				left: 0;
				position: absolute;
				transform: skew(0deg, -1.5deg);
				width: 100%;
				z-index: 2;

				@media (max-width: 936px) {
					bottom: -6px;
				}
			}
		}

		&-container-buttons {
			background-color: color(white);
			height: 357px;
			padding: 54px 0;
			z-index: 1;
		}
	}

	.show-form {
		.form-step-one {
			height: 100%;
			left: 0px;
			padding: 10px 0px;
			top: 0px;
			width: 100%;
		}
	}

	.back-primary {
		background-color: color(primary);
	}

	.back-qinti {
		background-color: #e4278e;
	}

	.link-here {
		background-color: color(newprimary);
		border-radius: 4px;
		color: color(white);
		display: inline-block;
		font-weight: 900;
		padding: 8px;
		text-decoration: none;
	}

	.link-admin {
		width: 101px;
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator-new/form-step-four-new.vue